<template>
  <div class="row">

    <div class="col-12">


      <div  v-if="showReport" class="mt-4 position-relative options-mand-list without-btn">

        <h4 class="stage-results__title">{{'report.table_prompts' | trans }}</h4>
        <table-view
            v-if="showReport"
            :options="optionsStatisticList"
            :isChange="isChangeStatic"
            :isList=isMobile
            class="stimulus_table"
        >


          <div slot="motivationCondition" slot-scope="props" class="nowrap">
            <div v-if="props.row.motivationCondition">{{'admin.yes' | trans }}</div>
            <div v-if="!props.row.motivationCondition">{{'admin.no' | trans }}</div>
          </div>

          <div slot="mandLevel" slot-scope="props" class="nowrap">
            <div v-if="props.row.mandLevel == 'spontaneous_level'">{{'protocol.spontaneous_level' | trans }}</div>
            <div v-if="props.row.mandLevel == 'with_subject'">{{'protocol.with_subject' | trans }}</div>
          </div>

          <div slot="action" slot-scope="props">
            <div v-if="props.row.name">
              <mdc-radio @change="choseSessionStimulus(props.row.id)" :checked="props.row.id == selectedId"
                         name="mandReaction"/>
            </div>
          </div>

        </table-view>

      </div>

      <div v-if="selectedId" class="mt-2 position-relative">

        <h4 class="stage-results__title">{{'report.statistics_mand' | trans }}</h4>
        <table-view
            v-if="selectedId"
            :options="optionsStimulReactionList"
            :isList=isMobile
            :isChange="isChangeStimul"
            class="stimulus_table"
        />

      </div>

      <div class="mt-3 mb-5" v-if="showReport && taskTypesMand.length && !isEmptyMand && selectedId">
        <div class="alert alert-secondary">
          <h4 class="stage-results__subtitle mb-3">{{'report.show_graph' | trans }}</h4>
          <mdc-switch class="switch--disabled" :checked="true" disabled>{{graphReactionTitle(7)}}: {{titleMandReaction}}  <span class="anchor_graph" @click.self="goToGraph(7)"></span>
          </mdc-switch>
          <mdc-switch class="switch--disabled"  :checked="true" disabled>{{graphReactionTitle(6)}}: {{titleMandReaction}} <span class="anchor_graph" @click.stop.prevent="goToGraph(6)"></span></mdc-switch>
          <mdc-switch v-model="showMandType1">{{graphReactionTitle(1)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType1 && inListOfSelectedType('1')" @click.stop.prevent="goToGraph(1)"></span></mdc-switch>
          <mdc-switch v-model="showMandType2">{{graphReactionTitle(2)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType2 && inListOfSelectedType('2')" @click.stop.prevent="goToGraph(2)"></span></mdc-switch>
          <mdc-switch v-model="showMandType3">{{graphReactionTitle(3)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType3 && inListOfSelectedType('3')" @click.stop.prevent="goToGraph(3)"></span></mdc-switch>
          <mdc-switch v-model="showMandType4">{{graphReactionTitle(4)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType4 && inListOfSelectedType('4')" @click.stop.prevent="goToGraph(4)"></span></mdc-switch>
          <mdc-switch v-model="showMandType5">{{graphReactionTitle(5)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType5 && inListOfSelectedType('5')" @click.stop.prevent="goToGraph(5)"></span></mdc-switch>
          <mdc-switch v-model="showMandType8">{{graphReactionTitle(8)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType8 && inListOfSelectedType('8')" @click.stop.prevent="goToGraph(8)"></span></mdc-switch>
          <mdc-switch v-model="showMandType9">{{graphReactionTitle(9)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType9 && inListOfSelectedType('9')" @click.stop.prevent="goToGraph(9)"></span></mdc-switch>
          <mdc-switch v-model="showMandType10">{{graphReactionTitle(10)}}: {{titleMandReaction}} <span class="anchor_graph" v-if="showMandType10 && inListOfSelectedType('10')" @click.stop.prevent="goToGraph(10)"></span></mdc-switch>

          <div class="row mt-3">
            <div class="col-12 text-right">
              <button type="button"
                      class="btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0" raised
                      @click.prevent="graphReactionShow()">
                {{'report.show_graph_btn' | trans}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="graphReaction  && selectedId && !isEmptyMand">

        <div v-for="(mandGraph, index) in graphReaction.chartData" :id="'mandGraphWrapp' + mandGraph.type" :ref="'mandGraphWrapp' + mandGraph.type">

          <current-stage-mand
              :mand-dataset="mandGraph.data"
              :mand-type="mandGraph.type"
              :mand-changes="graphReaction.changes"
              :mand-levels="graphReaction.levels"
              :mand-answers="graphReaction.answers"
              :mand-title="titleMandReaction"
              :mand-id="selectedId"
              :clientData="clientData"
              :protocolId="protocolId"
          />

        </div>

      </div>


    </div>

  </div>

</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineNonNumericYChart, LineChartDataset, LineChart} from '../../../common/chart';
  import filter from 'lodash/filter';
  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopup';
  import PromptChart from '../../chart/component/PromptChart';
  import CurrentStageMand from './CurrentStageMand';
  import toInteger from 'lodash/toInteger'
  
  export default {
    props: ['selectedStage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'stagesList', 'showReport', 'taskTypesMand', 'clientData'],
    components: {
      TableView, LineChart, LineChartDataset, LineNonNumericYChart, Loader, ChartPopup, PromptChart, CurrentStageMand
    },

    data() {
      return {
        isChangeStatic: false,
        showSimpleReport: true,
        apiUrl: '/protocols/assigned/',
        selectedId: null,
        chosenStimul: [],
        showMandType: true,
        showMandType1: false,
        showMandType2: false,
        showMandType3: false,
        showMandType4: false,
        showMandType5: false,
        showMandType7: false,
        showMandType8: false,
        showMandType9: false,
        showMandType10: false,
        list:[],
        graphReaction: null,
        graphReactionPointArray: [],
        graphReactionDays: null,
        graphReactionxLabels: null,
        chartSelectedType: [],
        optionsStatisticList: {
          initialPage: null,
          perPage: 10,
          pagination: {
            chunk: 20,
          },
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: false,
              headings: lang.get('protocol.name_mand_reaction')
            },
            {
              key: 'stage',
              changed: false,
              headings: lang.get('protocol.stage')
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: false,
              headings: lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: false,
              headings: lang.get('protocol.countSamples')
            },
            {
              key: 'action',
              changed: true,
              headings: lang.get('protocol.choose_stimul_chart')
            }
          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
          },
          listRow: {
            name: {
              headings: lang.get('protocol.name_mand_reaction'),
              hasTemplate: false,
            },
            stage: {
              headings: lang.get('protocol.stage'),
              hasTemplate: false,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestStimulListFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            answerTitle: 'text-center',
            mandLevel: 'text-center',
            motivationCondition: 'text-center',
            countSamples: 'text-center',
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
        optionsStimulReactionList: {
          pageHeader: 'mandList',
          initialPage: 1,
          perPage: 10,
          chunk: 20,
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'day',
              changed: false,
              headings: lang.get('protocol.date')
            },
            {
              key: 'secondDuration',
              changed: false,
              headings: lang.get('report.duration')
            },
            {
              key: 'withPrompts',
              changed: false,
              headings: lang.get('report.with_prompts')
            },
            {
              key: 'himself',
              changed: false,
              headings: lang.get('report.himself')
            },
            {
              key: 'spontaneous',
              changed: false,
              headings: lang.get('report.spontaneous')
            },
            {
              key: 'withPromptsHour',
              changed: false,
              headings: lang.get('report.with_prompts_per_hour')
            },
            {
              key: 'himselfPerHour',
              changed: false,
              headings: lang.get('report.himself_per_hour')
            },
            {
              key: 'spontaneousPerHour',
              changed: false,
              headings: lang.get('report.spontaneous_per_hour')
            },
          ],
          listRow: {
            day: {
              headings: lang.get('protocol.date'),
              hasTemplate: false,
            },
            secondDuration: {
              headings: lang.get('report.duration'),
              hasTemplate: true,
            },
            withPrompts: {
              headings: lang.get('report.with_prompts'),
              hasTemplate: false,
            },
            himself: {
              headings: lang.get('report.himself'),
              hasTemplate: false,
            },
            spontaneous: {
              headings: lang.get('report.spontaneous'),
              hasTemplate: false,
            },
            withPromptsHour: {
              headings: lang.get('report.with_prompts_per_hour'),
              hasTemplate: false,
            },
            himselfPerHour: {
              headings: lang.get('report.himself_per_hour'),
              hasTemplate: false,
            },
            spontaneousPerHour: {
              headings: lang.get('report.spontaneous_per_hour'),
              hasTemplate: false,
            },

          },
          requestFunction: this.requestStimulReactionListFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          templates: {
            day: this.day,
            secondDuration: this.secondDuration
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses: {
            secondDuration: 'text-center',
            himself: 'text-center',
            himselfPerHour: 'text-center',
            spontaneous: 'text-center',
            spontaneousPerHour: 'text-center',
            withPrompts: 'text-center',
            withPromptsHour: 'text-center'
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
      };
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      titleMandReaction: function () {
        let mandName = filter(this.list, mand => {
          return mand.id == this.selectedId
        });
        return mandName.length ? mandName[0].name : '';
      },

      isEmptyMand: function () {
        if (this.graphReaction) {
          if (!this.graphReaction.chartData[0].data.length) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      },

      showMand(){
        let showList = {
          '1': this.showMandType1,
          '2': this.showMandType2,
          '3': this.showMandType3,
          '4': this.showMandType4,
          '5': this.showMandType5,
          '8': this.showMandType8,
          '9': this.showMandType9,
          '10': this.showMandType10,
        };

        let array = [];

        forEach(showList, (item, key) => {
          if (item) {
            array.push(key)
          }
        });

        return array;
      },
      
    },

    async created() {
      //this.chartShow();
    },

    methods: {

      day(h, row) {
        return row.day ? this.toLocaleDate(row.day.date) : '';
      },

      secondDuration(h, row) {
        let minDuration = toInteger(row.secondDuration/60);
        let secDuration = row.secondDuration - minDuration*60;

        return minDuration + lang.get('report.min') + ' ' + secDuration  + lang.get('report.sec');
      },


      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      async requestStimulListFunction (data) {
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'mandList');
        this.isChangeStatic = false;
        return this.onSendReactionListRequest(this.optionsStatisticList.perPage, data.page);
      },

      onSendReactionListRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
        let params = {
          perPage: perPage,
          page: page,
          stageId: this.selectedStage ? this.selectedStage.id : null,
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
        };
        let response = await axios.get(url, {params: params});
        this.list = response.data.data.items;
        return response;
      },

      async requestStimulReactionListFunction (data) {
        this.isChangeStimul = false;
        return this.onSendMandReactionListRequest(this.optionsStimulReactionList.perPage, data.page);
      },

      onSendMandReactionListRequest: async function (perPage, page) {
        let url = this.apiUrl + 'mand/' + this.protocolId + '/stimulus-general-reactions-statistics/' + this.selectedId;
        let params = {
          perPage: perPage,
          page: page,
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
          stageId: this.selectedStage ? this.selectedStage.id : null,
        };
        let response = await axios.get(url, {params: params});
        return response;
      },

      checkedStimulus(id) {
        let checked = false;
        if (id && this.chosenStimul.length) {
          forEach(this.chosenStimul, stimul => {
            if (stimul.stimulusId == id || stimul.id == id) {
              checked = true;
            }
          })
        }

        return checked
      },


      async graphReactionShow(){
        this.graphReaction = null;
        this.isApplyFilter = true;
        this.isChangeStimul = true;
        let url = this.apiUrl + 'mand/' + this.protocolId + '/mensuration/' + this.selectedId;

        let chartTypes = this.showMand;
        let response = await axios.get(url, {
          params: {
            chartTypes: JSON.stringify(chartTypes),
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
            stageId: this.selectedStage ? this.selectedStage.id : null
          }
        });

        this.graphReaction = response.data.data;
        this.chartSelectedType = chartTypes;
        if (response) {
          this.isApplyFilter = false;
          this.isLoaded = true;
        }
      },

      async choseSessionStimulus(id) {
        this.selectedId = null;
        this.chartSelectedType = [];
        this.showMandType = false;
        this.showMandType1 = false;
        this.showMandType2 = false;
        this.showMandType3 = false;
        this.showMandType4 = false;
        this.showMandType5 = false;
        this.showMandType8 = false;
        this.showMandType9 = false;
        this.showMandType10 = false;
        this.isChangeStimul = false;
        this.graphReaction = null;
        this.isChangeStimuli = true;


        this.isApplyFilter = true;
        let url = this.apiUrl + 'mand/' + this.protocolId + '/mensuration/' + id;
        let chartTypes = [];
        let response = await axios.get(url, {
          params: {
            chartTypes: JSON.stringify(chartTypes),
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
            stageId: this.selectedStage ? this.selectedStage.id : null
          }
        });
        this.graphReaction = response.data.data;
        if (response) {
          this.selectedId = id;
          this.isApplyFilter = false;
          this.isLoaded = true;
          this.isChangeStimul = true;
        }

      },

      inListOfSelectedType(type){
        let selectType = filter(this.chartSelectedType, chartType =>{
          return chartType === type
        });

        console.info(this.chartSelectedType)

        return selectType.length;
      },

      graphReactionTitle(type){

        let first = this.taskTypesMand[0].title;
        let second = this.taskTypesMand[1].title;
        let third = this.taskTypesMand[4].title;
        let improve = this.taskTypesMand[2].title;

        switch (type) {
          case 1:
            return lang.get('report.graph_mo_yes_percent');
            break;
          case 2:
            return lang.get('report.graph_mo_yes');
            break;
          case 3:
            return lang.get('report.graph_probe', {
              'first': first,
              'second': second,
              'third': third,
            });
            break;
          case 4:
            return lang.get('report.graph_mo_goal');
            break;
          case 5:
            return lang.get('report.graph_mand_react', {
              'first': first,
              'second': second,
              'third': third,
            });
            break;
          case 6:
            return lang.get('report.graph_prompt_levels');
            break;
          case 7:
            return lang.get('report.graph_goal', {
              'first': first,
              'second': second,
              'third': third,
            });
            break;
          case 8:
            return lang.get('report.graph_cumulative_improve', {
              'first': first,
              'second': second,
              'third': third,
            });
            break;
          case 9:
            return lang.get('report.graph_improve_prompt', {
              'improve': improve
            });
            break;
          case 10:

            return lang.get('report.graph_improve', {
              'improve': improve
            });
            break;
          case 11:
            return lang.get('report.graph_relation_prompt', {
              'plus': '+',
              'second': second,
            });
            break;

        }
      },

      async chartSimpleShow(){

        this.showSimpleReport = true;

        this.loaded = true;
      },

      goToGraph(graphId){
        let graph = 'mandGraphWrapp' + graphId;
        setTimeout(() => {
          if(this.$refs[graph]){
            this.$refs[graph][0].scrollIntoView({behavior: "smooth"});
          }
        }, 200);
      }
      
    },

    watch:{
      showReport(newValue){

        if(!newValue){
          this.chosenStimul = [];
          this.isChangeStatic = true;
        }
      }
    }


  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentMand.vue